// Map a chart/file name to one of our instrument specs.
export function guessSymbol(name: string): string {
  const n = name.toLowerCase()
  if (/xau|gold/.test(n)) return 'XAUUSD'
  if (/btc|bitcoin|xbt/.test(n)) return 'BTCUSD'
  if (/nas|ndx|\bnq\b|ustech|us100/.test(n)) return 'NAS100'
  if (/spx|us500|sp500|s&p|es1/.test(n)) return 'US500'
  if (/dow|us30|dji|ym1/.test(n)) return 'US30'
  if (/nikkei|jp225|jpn225|nik/.test(n)) return 'JP225'
  return 'XAUUSD'
}
